import { render, staticRenderFns } from "./SalaryAudit.vue?vue&type=template&id=4b8c8a82&scoped=true&"
import script from "./SalaryAudit.vue?vue&type=script&lang=js&"
export * from "./SalaryAudit.vue?vue&type=script&lang=js&"
import style0 from "./SalaryAudit.vue?vue&type=style&index=0&id=4b8c8a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c8a82",
  null
  
)

export default component.exports